import React from "react";
import { Box, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { useSelector } from "react-redux";
import { isTextHebrew } from "styles/theme/utils";

const FreeTextMobileHints = () => {
  const { t } = useTranslation();
  const answer = useSelector(selectAnswer);

  return (
    <Tooltip
      followCursor
      title={t("QUESTIONS.FORM.LABELS.MOBILE_TOOLTIP_HINT_TOOLTIP")}
    >
      <Box
        sx={{
          marginTop: "16px",
          borderRadius: "4px",
          padding: "5px",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          justifyContent: "left",
          gap: "8px",
          border: "1px solid #ccc",
        }}
      >
        {answer?.free_text?.map((item, index) => {
          const letters = item?.letters || [];
          const option1Txt = letters
            .filter((el) => el.option1)
            .map((el) => el.option1)
            .join("");
            
          const relevantData = isTextHebrew(option1Txt)
            ? item.isPlotRTL
              ? letters
              : [...letters].reverse()
            : item.isPlotRTL
            ? [...letters].reverse()
            : letters;

          const option1 = relevantData
            .filter((el) => el.option1)
            .map((el) => el.option1)
            .join("");
          const option2 = relevantData
            .filter((el) => el.option2 || el.option1)
            .map((el) => el.option2 || el.option1)
            .join("");
          const word = [option1, option2].filter(Boolean).join(" / ");

          return (
            <Typography key={index} fontWeight={500} fontSize={14}>
              {t("QUESTIONS.FORM.LABELS.FREE_TEXT_MOBILE_HINT", {
                num: index + 1,
                word,
              })}
            </Typography>
          );
        })}
      </Box>
    </Tooltip>
  );
};

export default FreeTextMobileHints;
